import { useEffect, useState } from "react";
import { type Theme, getInitialTheme, setTheme } from "../lib/theme";

// Appbar control that flips light/dark. The choice is persisted to localStorage
// and reflected onto <html data-theme> (see lib/theme + the inline no-flash
// script in index.html). Inline SVG only — sun in dark mode (click → light),
// moon in light mode (click → dark).
export function ThemeToggle() {
  const [theme, setThemeState] = useState<Theme>(() => getInitialTheme());

  // Keep the attribute in sync (the inline script set the initial one; this
  // re-affirms it and covers the case where storage and DOM ever diverge).
  useEffect(() => {
    setTheme(theme);
  }, [theme]);

  const isDark = theme === "dark";

  function toggle() {
    setThemeState(isDark ? "light" : "dark");
  }

  return (
    <button
      type="button"
      className="iconbtn theme-toggle"
      onClick={toggle}
      aria-pressed={isDark}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
    >
      {isDark ? (
        // Sun
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      ) : (
        // Moon
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.8}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
        </svg>
      )}
    </button>
  );
}
